module.exports = __webpack_public_path__ + "img/ellipsis-h.30fc3bdc.svg";